import axios, {AxiosInstance, AxiosRequestConfig} from 'axios'
import jwt, {JwtPayload} from 'jwt-decode'
import {showNotification} from "common/Notification"
import {AccessTokenInfo} from "dto/auth/Authentication"
import {getLocalAccessTokenInfo, setLocalAccessToken} from "lib/http/token-management"


const defaultAxios: AxiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/wheelchair/api/v1`,
    headers: {
        'Content-type': 'application/json',
        // 'Authentication': `Bearer ${localStorage.getItem("access_token")}`,
    }
})

const checkToken = async (config: AxiosRequestConfig) => {
    if (!config) return config
    let tokenInfo = getLocalAccessTokenInfo()
    let accessToken = tokenInfo.access_token
    if (tokenInfo.access_token && tokenInfo.access_token !== "") {
        // const decode = JSON.parse(tokenInfo.access_token)
        const decode = jwt<JwtPayload>(tokenInfo.access_token)
        const nowDate = new Date().getTime() / 1000
        if (!decode) return config
        if ((decode.exp || 0) < nowDate) {
            try {
                const {data, status} = await authAxios.post(`${process.env.REACT_APP_AUTH_URL}/auth/refreshToken`, {
                    // const {data, status} = await authAxios.post(`${process.env.REACT_APP_AUTH_URL}`, {
                    //     clientId: "public",
                    grantType: "refresh_token",
                    refreshToken: tokenInfo.refresh_token
                })
                console.log("status : ", status)
                const token = data.body as AccessTokenInfo
                await setLocalAccessToken(token)
                accessToken = token.access_token
            } catch (error) {
                console.log("exception: ", error)
                // @ts-ignore
                if (error?.response) {
                    // @ts-ignore
                    console.log("client received an error response : 4xx, 5xx", error?.response)
                    showNotification("서버에서 오류가 발생하였습니다")

                    window.location.pathname = "/login"
                    // @ts-ignore
                } else if (error?.code === "ECONNABORTED") {
                    console.log("client timeout")
                    showNotification("서버와 연결할 수 없습니다")
                    // @ts-ignore
                } else if (error?.request) {
                    console.log("client never received a response, or request never left")
                    showNotification("서버와 통신이 길어지고 있습니다. 다시 시도하여 주시기 바랍니다")
                } else {
                    showNotification("유효하지 않은 접근입니다. 다시 로그인해 주세요")
                    window.location.pathname = "/login"
                }
            }

        }
    }
    if (config && config.headers) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
    }

    return config
}
const loginAgain = () => {
    setTimeout(() => {
        window.location.href = "/login"
    }, 2000)
}
const checkResponseError = (error: any) => {
    if (error?.response) {
        if (error?.response.status === 503) {
            showNotification("서비스 연결을 할 수 없습니다. 해당 서비스가 동작중인지 확인하여 주세요")
            // loginAgain()
        }
        if (error?.response.status === 401) {
            showNotification("권한이 없는 API를 호출하였습니다. 오류가 지속될 경우 다시 로그인 하여 주세요")
            loginAgain()
        }
    }
    if(error) {
        throw error
    }
    console.log("response: ", error)
}
export const authAxios = axios.create({
    baseURL: process.env.REACT_APP_AUTH_URL,
})

defaultAxios.interceptors.request.use(checkToken)
defaultAxios.interceptors.response.use(res => res, checkResponseError)

authAxios.interceptors.response.use(undefined, checkResponseError)


export const fileResourceAxios = axios.create({
    baseURL: `${process.env.REACT_APP_BASE_URL}/file-resource/api/v1/file`,
})

fileResourceAxios.interceptors.request.use(checkToken)
fileResourceAxios.interceptors.response.use(res => res, checkResponseError)

export default defaultAxios